import { CategoriesDetailParser } from '@services/http/parsers/categories-detail-response.parser';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetCategoriesDetailRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'categories';

  /**
   * @inheritdoc
   */
  responseParser = new CategoriesDetailParser();

  cache = true;

  /**
   * @inheritdoc
   */
  constructor(id, language) {
    super(language);
    this.relativePath = `${this.relativePath}/${id}`;
  }

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
